import React, { Component } from 'react';
import moment from 'moment-timezone';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { timePrefixZero, timePrefixZeroFromSeconds } from '../../utilities/timeUtility';

export default class Timer extends Component {
  state = {
    timer: this.timerFromProps(),
    timerId: 0,
  };

  componentDidMount() {
    this.startTimer();
  }

  componentWillUnmount() {
    this.stopTimer();
  }

  timerFromProps() {
    const { seconds, expiresAt } = this.props;
    if (seconds) return timePrefixZeroFromSeconds(seconds);
    if (expiresAt) return timePrefixZero(expiresAt);
    return '00:00'
  }

  startTimer() {
    if (!this.state.timerId) {
      const timerId = setInterval(() => {
        let timer = moment(this.state.timer, ['mm:ss']);

        if (timer.format('mm:ss') === '00:00') {
          this.stopTimer();
          this.props.onExpired();
        } else {
          timer = timer.subtract(1, 'seconds').format('mm:ss');
          this.setState({ timer });
        }
      }, 1000);

      this.setState({ timerId });
    }
  }

  stopTimer() {
    clearInterval(this.state.timerId);
    this.setState({ timerId: 0 });
  }

  render() {
    return (
      <div>
        {<FontAwesomeIcon style={{ marginRight: '3px' }} icon="clock" />}
        {' '}
        {this.state.timer}
      </div>
    );
  }
}
